export default __webpack_public_path__ + "static/media/icon-info-panel-1.0acc4aed.svg";